import React, { useState, useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'info', size = 'normal', duration = 4000, onClose }) => {
  const [animationPhase, setAnimationPhase] = useState('droplet'); // droplet -> falling -> expanding -> visible

  useEffect(() => {
    // Phase 1: Start as ball
    const fallTimer = setTimeout(() => {
      setAnimationPhase('falling');
    }, 150);

    // Phase 2: Fall down
    const expandTimer = setTimeout(() => {
      setAnimationPhase('expanding');
    }, 800);

    // Phase 3: Expand to full message (longer duration for smoother expansion)
    const visibleTimer = setTimeout(() => {
      setAnimationPhase('visible');
    }, 1600);

    // Auto-hide after duration
    const autoHideDuration = duration + 1600;
    const hideTimer = setTimeout(() => {
      setAnimationPhase('hiding');
      setTimeout(onClose, 500);
    }, autoHideDuration);

    return () => {
      clearTimeout(fallTimer);
      clearTimeout(expandTimer);
      clearTimeout(visibleTimer);
      clearTimeout(hideTimer);
    };
  }, [duration, onClose, size]);

  const getToastIcon = () => {
    switch (type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '⚠';
      default: return 'ℹ';
    }
  };

  const getToastColor = () => {
    switch (type) {
      case 'success': return '#10b981';
      case 'error': return '#ef4444';
      case 'warning': return '#f59e0b';
      default: return '#3b82f6';
    }
  };

  return (
    <div className={`morphing-toast toast-${type} toast-${size} phase-${animationPhase}`}>
      {/* Content that appears during expansion */}
      <div className="toast-content">
        <div className="toast-icon" style={{ backgroundColor: getToastColor() }}>
          {getToastIcon()}
        </div>
        <div className="toast-message">
          {typeof message === 'string' ? (
            message
          ) : (
            <div className="toast-rich-content">{message}</div>
          )}
        </div>
        <button 
          className="toast-close" 
          onClick={() => {
            setAnimationPhase('hiding');
            setTimeout(onClose, 400);
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;